// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__maGHT","fadeIn":"Spinner_fadeIn__blnth","spinner":"Spinner_spinner__I+iHd","zoom":"Spinner_zoom__N+uBn","text":"Spinner_text__bChEY"};